var _path, _path2, _path3, _path4, _path5, _path6, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewUser = function SvgNewUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0534 36.1583L59.0501 9.78515C59.0501 5.25704 55.3793 1.58626 50.8512 1.58626H17.2509C12.7228 1.58626 9.052 5.25704 9.052 9.78515V57.8853C9.052 62.4134 12.7228 66.0842 17.2509 66.0842L42.7966 66.0766L59.0573 49.8307",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9836 45.0403L36.2371 45.0326",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9836 55.0159L32.5476 55.0082",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7964 66.0767V56.6631C42.7964 52.8897 45.8554 49.8307 49.6288 49.8307H59.0575",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0461 16.8373C28.0461 13.5921 30.6769 10.9614 33.922 10.9614C37.1671 10.9614 39.7979 13.5921 39.7979 16.8373C39.7979 20.0824 37.1671 22.7131 33.922 22.7131C30.6769 22.7131 28.0461 20.0824 28.0461 16.8373Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4055 31.1881C43.4002 26.3487 39.1208 22.713 33.994 22.713H33.851C28.7242 22.713 24.4448 26.3487 23.4395 31.1881C22.6889 34.8004 28.1512 35.8726 33.994 35.8726C39.8369 35.8725 45.1561 34.8004 44.4055 31.1881Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0298,
    cy: 42.6911,
    rx: 1.26268,
    ry: 1.26268,
    fill: "#757575"
  })));
};
export default SvgNewUser;